"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const svgParcel_1 = require("@common/tsutils/svgParcel");
let SvgParcel = class SvgParcel extends vue_property_decorator_1.Vue {
    //
    // Variables for circle fallback
    //
    get cx() {
        return this.width / 2;
    }
    get cy() {
        return this.height / 2;
    }
    get r() {
        return Math.min(this.cx, this.cy) * 0.75;
    }
    //
    // Variable for parcel path
    //
    get path() {
        if (!this.parcel_str)
            return '';
        return (0, svgParcel_1.parcelPolygon2SvgPath)(this.parcel_str, this.width, this.height);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 100 })
], SvgParcel.prototype, "width", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 100 })
], SvgParcel.prototype, "height", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '#bbbbbb' })
], SvgParcel.prototype, "color", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 1 })
], SvgParcel.prototype, "stroke", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '#000000' })
], SvgParcel.prototype, "stroke_color", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], SvgParcel.prototype, "parcel_str", void 0);
SvgParcel = __decorate([
    (0, vue_property_decorator_1.Options)({})
], SvgParcel);
exports.default = SvgParcel;
